













import TitleBar from '@/modules/core/components/TitleBar.vue';
import SubscriptionEdit from '../components/SubscriptionEdit.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    TitleBar,
    SubscriptionEdit,
  },
})
export default class SubscriptionEditPage extends Vue {
  public get titleStack(): string[] {
    return [
      'Admin',
      'Edition de la programmation',
    ];
  }

  public get subscriptionId(): string {
    return this.$router.currentRoute.params.id;
  }

  public subscriptionEdited(): void {
    this.goBack();
  }

  public goBack(): void {
    this.$router.go(-1);
  }
}
